import React from 'react'
import { MagentoAvailablePaymentMethod } from 'lib/types'
import { PaymentOption } from './styled'

interface Props {
  method: MagentoAvailablePaymentMethod
  onChange: (method: MagentoAvailablePaymentMethod) => any
  isSelected: boolean
}

export const Option: React.FC<Props> = ({
  method,
  onChange,
  isSelected,
  children
}) => {
  return (
    <PaymentOption>
      <label>
        <input
          checked={isSelected}
          name='payment_method'
          type='radio'
          onChange={() => onChange(method)}
        />
        <span>
          {children}
        </span>
      </label>
    </PaymentOption>
  )
}
